import {
    GENERATE_PHYSICIAN_NOTIFICATIONS,
    GENERATE_PHYSICIAN_NOTIFICATIONS_SUCCESS,
    GENERATE_PHYSICIAN_NOTIFICATIONS_FAILED,

    FETCH_PHYSICIAN_NOTIFICATIONS,
    FETCH_PHYSICIAN_NOTIFICATIONS_SUCCESS,
    FETCH_PHYSICIAN_NOTIFICATIONS_FAILED,

    UPDATE_PHYSICIAN_NOTIFICATION,
    UPDATE_PHYSICIAN_NOTIFICATION_SUCCESS,
    UPDATE_PHYSICIAN_NOTIFICATION_FAILED,

    FETCH_DEALLOCATION_NOTIFICATIONS,
    FETCH_DEALLOCATION_NOTIFICATIONS_SUCCESS,
    FETCH_DEALLOCATION_NOTIFICATIONS_FAILED,

    FETCH_PATIENT_WITH_LAST_NIGHT_DATA,
    FETCH_PATIENT_WITH_LAST_NIGHT_DATA_SUCCESS,
    FETCH_PATIENT_WITH_LAST_NIGHT_DATA_FAILED,
    FETCH_PATIENT_WITH_NO_DATA,
    FETCH_PATIENT_WITH_NO_DATA_SUCCESS,
    FETCH_PATIENT_WITH_NO_DATA_FAILED,
    FETCH_RECENT_PATIENT_DATA,
    FETCH_RECENT_PATIENT_DATA_SUCCESS,
    FETCH_RECENT_PATIENT_DATA_FAILED,
    NO_CHECK_FOR_LONG,
    FETCH_NO_CHECK_FOR_LONG_SUCCESS,
    FETCH_NO_CHECK_FOR_LONG_FAILED,
    FETCH_WIDGETS,
    FETCH_WIDGETS_SUCCESS,
    FETCH_WIDGETS_FAILED
} from "constants/ActionTypes";

export const generate_physician_notifications = () => {
    return {
        type: GENERATE_PHYSICIAN_NOTIFICATIONS
    }
}

export const generate_physician_notifications_success = (data) => {
    return {
        type: GENERATE_PHYSICIAN_NOTIFICATIONS_SUCCESS,
        data
    }
}

export const generate_physician_notifications_failed = (error) => {
    return {
        type: GENERATE_PHYSICIAN_NOTIFICATIONS_FAILED,
        error
    }
}

export const fetch_physician_notifications = () => {
    return {
        type: FETCH_PHYSICIAN_NOTIFICATIONS
    }
}

export const fetch_physician_notifications_success = (data) => {
    return {
        type: FETCH_PHYSICIAN_NOTIFICATIONS_SUCCESS,
        data,
    }
}

export const fetch_physician_notifications_failed = (error) => {
    return {
        type: FETCH_PHYSICIAN_NOTIFICATIONS_FAILED,
        error
    }
}

export const update_physician_notification = (payload) => {
    return {
        type: UPDATE_PHYSICIAN_NOTIFICATION,
        payload
    }
}

export const update_physician_notification_success = (data) => {
    return {
        type: UPDATE_PHYSICIAN_NOTIFICATION_SUCCESS,
        data
    }
}

export const update_physician_notification_failed = (error) => {
    return {
        type: UPDATE_PHYSICIAN_NOTIFICATION_FAILED,
        error
    }
}

export const fetch_deallocation_notifications = () => {
    return {
        type: FETCH_DEALLOCATION_NOTIFICATIONS
    }
}

export const fetch_deallocation_notifications_success = (data) => {
    return {
        type: FETCH_DEALLOCATION_NOTIFICATIONS_SUCCESS,
        data,
    }
}

export const fetch_deallocation_notifications_failed = (error) => {
    return {
        type: FETCH_DEALLOCATION_NOTIFICATIONS_FAILED,
        error
    }
}

export const fetch_widgets = () => {
    return {
        type: FETCH_WIDGETS
    }
}

export const fetch_widgets_success = (payload) => {
    return {
        type: FETCH_WIDGETS_SUCCESS,
        payload
    }
}

export const fetch_widgets_failed = (error) => {
    return {
        type: FETCH_WIDGETS_FAILED,
        error
    }
}

export const fetch_patient_with_last_night_data = () => {
    return {
        type: FETCH_PATIENT_WITH_LAST_NIGHT_DATA,
    };
};
export const fetch_patient_with_last_night_data_success = (payload) => ({
    type: FETCH_PATIENT_WITH_LAST_NIGHT_DATA_SUCCESS,
    payload
})
export const fetch_patient_with_last_night_data_failed = (error) => ({
    type: FETCH_PATIENT_WITH_LAST_NIGHT_DATA_FAILED,
    error
})

export const fetch_patient_with_no_data = () => {
    return {
        type: FETCH_PATIENT_WITH_NO_DATA,
    };
};
export const fetch_patient_with_no_data_success = (payload) => ({
    type: FETCH_PATIENT_WITH_NO_DATA_SUCCESS,
    payload
})

export const fetch_patient_with_no_data_failed = (error) => ({
    type: FETCH_PATIENT_WITH_NO_DATA_FAILED,
    error
})
export const fetch_recent_patient = (payload) => {
    return {
        type: FETCH_RECENT_PATIENT_DATA,
        payload,
    }
};
export const fetch_recent_patient_success = (payload) => {
    return {
        type: FETCH_RECENT_PATIENT_DATA_SUCCESS,
        payload,
    }
};
export const fetch_recent_patient_failed = (error) => {
    return {
        type: FETCH_RECENT_PATIENT_DATA_FAILED,
        error,
    }
};
export const no_check_for_long = () => {
    return {
        type: NO_CHECK_FOR_LONG,
    }
};
export const fetch_no_check_for_long_success = (payload) => {
    return {
        type: FETCH_NO_CHECK_FOR_LONG_SUCCESS,
        payload,
    }
};
export const fetch_no_check_for_long_failed = (error) => {
    return {
        type: FETCH_NO_CHECK_FOR_LONG_FAILED,
        error,
    }
}
